import React, { FC } from "react";
import { Avatar, Button, Card, Dropdown, Menu } from "antd";
import { DownOutlined, LogoutOutlined, SettingFilled, UserOutlined } from "@ant-design/icons";
import styles from "./user-menu.css";
import { User } from "../../graphql/types";

import { Link } from "react-router-dom";

export type UserMenuProps = {
  user: User;
  onClickLogout: () => void;
};

export const UserMenu: FC<UserMenuProps> = ({ user, onClickLogout }) => {
  const logoutButton = (
    <Button key="logout" type="text" icon={<LogoutOutlined />} onClick={() => onClickLogout()}>
      Logout
    </Button>
  );

  const { displayName, initials, pictureUrl } = user;
  const avatar = (pictureUrl && <Avatar src={pictureUrl} className={styles.avatar} />) ||
    (initials && <Avatar className={styles.avatar}>{initials}</Avatar>) || (
      <Avatar icon={<UserOutlined className={styles.avatar} />} />
    );

  const menu = (
    <Menu>
      <Menu.Item key="user">
        <Card bordered={false} actions={[logoutButton]}>
          <Card.Meta
            avatar={avatar}
            title={
              <Link to="/user-settings">
                <span>
                  {displayName}
                  <SettingFilled className={styles.settings} />
                </span>
              </Link>
            }
          />
        </Card>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className={styles.container}>
      <Dropdown overlay={menu} className={styles.dropdown}>
        <div className={styles.container2}>
          {avatar}
          <Button
            className={styles.dropButton}
            style={{ padding: 0, margin: 0, outline: "none" }}
            type="text"
          >
            <DownOutlined className={styles.dropdown} style={{ color: "#fff", width: "20px" }} />
          </Button>
        </div>
      </Dropdown>
    </div>
  );
};
